import * as ContentWithSelectedFlights from './ContentWithSelectedFlights/ContentWithSelectedFlights.css';
import * as Flights from './Flights/Flights.css';
import * as Layout from './Layout/Layout.css';
import * as Receipt from './Receipt/Receipt.css';
import * as Request from './Request/Request.css';
import * as SearchFlights from './SearchFlights/SearchFlights.css';
import * as Segments from './Segments/Segments.css';
import * as SelectedFlights from './SelectedFlights/SelectedFlights.css';
import * as ExchangeRequestControls from './ExchangeRequestControls/ExchangeRequestControls.css';
export default {
    ContentWithSelectedFlights,
    Flights,
    Layout,
    Receipt,
    Request,
    SearchFlights,
    Segments,
    SelectedFlights,
    ExchangeRequestControls
};
